;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('join', JoinFilter)

  function JoinFilter () {
    var operation = function (arr, char) {
      return arr ? arr.join(char || ' ') : ''
    }

    /**
     * Return callback to execute SliceFilter
     */
    return operation
  }
})(window.angular)
